import styled from 'styled-components'

import { DocumentCategoryLabel } from '../../../domain/enums/documents.enum'

export const ShortListWrapper = styled.div`
  padding: 1.5rem;
  display: flex;
  flex-direction: column;
  background: ${(props) => props.theme.gradient.cardBackground};
  box-shadow: ${(props) => props.theme.shadow.main};
  border-radius: 6px;
  color: ${(props) => props.theme.colors.white};
  width: 100%;
`

export const CenterWrapper = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  & p {
    padding: 0.5rem;
  }
  width: 100%;
`

export const Title = styled.div`
  padding-bottom: 0.5rem;
`

export const ViewButton = styled.button`
  background-color: transparent;
  border: none;
  color: ${(props) => props.theme.colors.whiteAlpha40};
  cursor: pointer;
  border-radius: 4px;
  &:hover {
    color: ${(props) => props.theme.colors.primaryColor500};
  }
  &:focus {
    outline: none;
    background-color: ${(props) => props.theme.colors.neutralColor500};
  }
  &:disabled {
    cursor: default;
    background-color: transparent;
    &:hover {
      color: ${(props) => props.theme.colors.whiteAlpha20};
    }
  }
`

export const Element = styled.td`
  padding: 0.5rem 1.5rem 0.5rem 0rem;
  color: ${(props) => props.theme.colors.whiteAlpha40};
  font-size: ${(props) => props.theme.sizes.h4};
`

export const Name = styled.div`
  color: ${(props) => props.theme.colors.white};
`

export const StyledDate = styled.div`
  font-size: ${(props) => props.theme.sizes.h6};
`
export const StyledCategory = styled.div`
  border-radius: 4px;
  padding: 0.5rem;
  background-color: ${(props) => {
    if (props.color === DocumentCategoryLabel.PRODUCTION) {
      return props.theme.colors.carefulColor100
    }
    if (props.color === DocumentCategoryLabel.INTERVENTION) {
      return props.theme.colors.secondaryColor100
    }
    return props.theme.colors.secondaryColor500
  }};

  color: ${(props) => {
    if (props.color === DocumentCategoryLabel.PRODUCTION) {
      return props.theme.colors.carefulColor700
    }
    if (props.color === DocumentCategoryLabel.INTERVENTION) {
      return props.theme.colors.secondaryColor700
    }
    return props.theme.colors.neutralColor700
  }};
`

export const StyledTable = styled.table`
  width: 100%;
`
